var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('router-link',{staticClass:"menu-item item-link",attrs:{"to":"/aplicatii/m3-sketch"}},[_c('img',{attrs:{"alt":"POC Sketch","src":require("@/assets/images/sketch_new.png")}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }